module.exports = __webpack_public_path__ + "img/20190702160616771.6ef4e4f7.png";